module.exports = __webpack_public_path__ + "img/b6be838.png";